import { useState, useEffect } from "react";
import { getTranslations } from "../../../../../../services/languageUtils";

const savePDF = (resultPayment) => {
  window.location.href = "/accounts/statements";
};

function TransferComplete({ resultPayment, type }) {
  const [translations, setTranslations] = useState({});
  const creditParty = resultPayment?.creditParty || {};
  const safeAmount = Number(resultPayment?.amount || 0);

  useEffect(() => {
    const loadTranslations = async () => {
      const trans = await getTranslations(
        localStorage.getItem("language") || "pt",
      );
      setTranslations(trans);
    };
    loadTranslations();
  }, []);
  return (
    <div>
      {type !== "batch" && (
        <div className="mainContent">
          <p className="pTitle">{translations.transfer_order_resume}</p>
          <p className="pLabel">{creditParty.name || "-"}</p>

          <div className="contentSpaceBetween">
            <p className="labelGray">{translations.pix_key}</p>
            <b>{creditParty.key || creditParty.pixKey || "-"}</b>
          </div>
          <div className="contentSpaceBetween">
            <p className="labelGray">{translations.payment_institution}</p>
            <b>{creditParty.bank || "-"}</b>
          </div>
          <div className="contentSpaceBetween">
            <p className="labelGray">{translations.branch}</p>
            <b>{creditParty.branch || "-"}</b>
          </div>
          <div className="contentSpaceBetween">
            <p className="labelGray">{translations.account}</p>
            <b>{creditParty.account || "-"}</b>
          </div>
          <div className="contentSpaceBetween">
            <p className="labelGray">{translations.value}</p>
            <b>
              {safeAmount.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </b>
          </div>
          <div className="contentSpaceBetween">
            <p className="labelGray">{translations.transaction_id}</p>
            <b>{resultPayment.id}</b>
          </div>
          <br />
        </div>
      )}

      <div
        className="mainContent"
        style={{ borderRadius: "0px 8px 8px 0px", textAlign: "center" }}
      >
        <br />
        <br />
        <b>
          <img
            src={
              require("../../../../../../assets/imgs/ico-higher-bg.svg").default
            }
            alt={translations.success_icon_alt}
            className="imgSuccess"
          />
          {translations.transfer_completed_successfully}
        </b>
        <br />
        <br />
        {type !== "batch" && (
          <div
            className="buttonShare"
            style={{ cursor: "pointer" }}
            onClick={() => {
              savePDF(resultPayment);
            }}
          >
            Visualizar comprovante
          </div>
        )}
      </div>
    </div>
  );
}

export default TransferComplete;
